import React, { Component } from 'react'
import NaturalSearch from './searchCategory/NaturalSearch'
import KeywordSearch from './searchCategory/KeywordSearch'
import PaperSearch from './searchCategory/PaperSearch'
import Organisms from "./Organisms"

class searchList extends Component {
    constructor(props) {
        super(props);

        this.state = {

        };

    }

    getSearchCategory() {

        let data = this.props.data;

        if (data.type === "Natural Language Search")
            return <NaturalSearch data={data}
                addLibrary={(type, id, code) => this.props.addLibrary(type, id, code)}
                addSearchKeyword={(keyword) => this.props.addSearchKeyword(keyword)}
                deleteItem={() => this.props.deleteItem()}
                beforeItem={this.props.beforeItem}
                editItem={(data, keyword) => this.props.editItem(data, keyword)}
                selectedKeyword={this.props.keyword}
                searchList={this.props.searchList}
                libraryList={this.props.libraryList}
                userId={this.props.userId} accessToken={this.props.accessToken} />
        else if (data.type === "Articles" || data.type === "Patents")
            return <PaperSearch data={data}
                addLibrary={(type, id, code) => this.props.addLibrary(type, id, code)}
                addSearchKeyword={(keyword) => this.props.addSearchKeyword(keyword)}
                keywordDetail={(e, keyword) => this.props.keywordDetail(e, keyword)}
                deleteItem={() => this.props.deleteItem()}
                beforeItem={this.props.beforeItem}
                editItem={(data, keyword, keywordAll) => this.props.editItem(data, keyword, keywordAll)}
                selectedKeyword={this.props.keyword}
                searchList={this.props.searchList}
                libraryList={this.props.libraryList}
                userId={this.props.userId} accessToken={this.props.accessToken} />
        else if (data.type === "Biological Systems" || data.type === "Organisms")
            return <Organisms data={data}
                addLibrary={(type, id, code) => this.props.addLibrary(type, id, code)}
                addSearchKeyword={(keyword) => this.props.addSearchKeyword(keyword)}
                keywordDetail={(e, keyword) => this.props.keywordDetail(e, keyword)}
                deleteItem={() => this.props.deleteItem()}
                beforeItem={this.props.beforeItem}
                editItem={(data, keyword, keywordAll) => this.props.editItem(data, keyword, keywordAll)}
                selectedKeyword={this.props.keyword}
                searchList={this.props.searchList}
                libraryList={this.props.libraryList}
                userId={this.props.userId} accessToken={this.props.accessToken} />
        else
            return <KeywordSearch data={data}
                addLibrary={(type, id, code) => this.props.addLibrary(type, id, code)}
                type={data.type} addSearchKeyword={(keyword) => this.props.addSearchKeyword(keyword)}
                keywordDetail={(e, keyword) => this.props.keywordDetail(e, keyword)}
                deleteItem={() => this.props.deleteItem()}
                beforeItem={this.props.beforeItem}
                editItem={(data, keyword, keywordAll) => this.props.editItem(data, keyword, keywordAll)}
                selectedKeyword={this.props.keyword}
                searchList={this.props.searchList}
                libraryList={this.props.libraryList}
                userId={this.props.userId} accessToken={this.props.accessToken} />



    }


    render() {

        return (
            <React.Fragment>
                {this.getSearchCategory()}
            </React.Fragment>
        )
    }
}


export default searchList;